import { Link } from "react-router-dom";
import { Mail, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="main-footer" className="bg-[#1C1C1C] text-[#FDFBF7]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-20">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <h3 className="font-['Playfair_Display'] text-2xl font-medium mb-4 text-[#FDFBF7]">
              Dr. Erika Tajra
            </h3>
            <p className="text-sm text-[#FDFBF7]/60 leading-relaxed max-w-md">
              Personalised health and wellness consulting through nutrigenomics,
              microbiome science, and evidence-based longevity strategies.
              Your biology is unique — your health plan should be too.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-medium tracking-widest uppercase text-[#D4AF37] mb-6">
              Navigate
            </h4>
            <nav className="flex flex-col gap-3">
              <Link to="/" className="text-sm text-[#FDFBF7]/60 hover:text-[#D4AF37] transition-colors">Home</Link>
              <Link to="/about" className="text-sm text-[#FDFBF7]/60 hover:text-[#D4AF37] transition-colors">About</Link>
              <Link to="/blog" className="text-sm text-[#FDFBF7]/60 hover:text-[#D4AF37] transition-colors">Blog</Link>
              <Link to="/contact" className="text-sm text-[#FDFBF7]/60 hover:text-[#D4AF37] transition-colors">Contact</Link>
              <Link to="/apply" className="text-sm text-[#FDFBF7]/60 hover:text-[#D4AF37] transition-colors">Apply for Consultation</Link>
            </nav>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-medium tracking-widest uppercase text-[#D4AF37] mb-6">
              Contact
            </h4>
            <div className="flex flex-col gap-4">
              <div className="flex items-start gap-3">
                <Mail size={16} className="text-[#D4AF37] mt-0.5 flex-shrink-0" />
                <span className="text-sm text-[#FDFBF7]/60">hello@drerikatajra.com</span>
              </div>
              <div className="flex items-start gap-3">
                <MapPin size={16} className="text-[#D4AF37] mt-0.5 flex-shrink-0" />
                <span className="text-sm text-[#FDFBF7]/60">London, United Kingdom</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-[#FDFBF7]/10 mt-16 pt-8">
          {/* Legal Disclaimer */}
          <div className="mb-8 pb-8 border-b border-[#FDFBF7]/10">
            <p className="text-xs text-[#FDFBF7]/30 leading-relaxed max-w-4xl">
              <span className="text-[#FDFBF7]/50 font-medium">Disclaimer:</span>{" "}
              Erika Tajra holds a medical degree from St. George's University of London,
              a Master's in Personalised Medicine and Genomics from UCL Great Ormond Street
              Hospital, and a Diploma in Global Health from Harvard University. These are
              UK and international qualifications.{" "}
              <span className="text-[#FDFBF7]/50 font-medium">
                Erika is not a licensed physician in the United States or any US state
                and does not diagnose, treat, cure, or prescribe for any medical condition.
              </span>{" "}
              The services offered are health and wellness consultations for educational
              and informational purposes. They are not a substitute for professional medical
              advice, diagnosis, or treatment from a licensed healthcare provider. Always seek
              the advice of a qualified, licensed physician or healthcare professional with
              any questions regarding a medical condition. If you require medical treatment
              or prescriptions, Erika can refer you to licensed physicians within her
              professional network.
            </p>
          </div>

          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-xs text-[#FDFBF7]/40">
              &copy; {new Date().getFullYear()} Erika Tajra. All rights reserved.
            </p>
            <p className="text-xs text-[#FDFBF7]/40">
              Health &amp; Wellness Consulting &middot; London
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
